const root = 'UserLoginInfoSettings'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
  username: `${root}-username`,
  usernameHelperText: `${root}-usernameHelperText`,
  currentPassword: `${root}-currentPassword`,
  newPassword: `${root}-newPassword`,
  newPasswordToggleVisibilityButton: `${root}-newPassword-toggleVisibilityButton`,
}
